var _rect, _rect2, _rect3, _rect4, _g, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalheaderimg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 88,
    viewBox: "0 0 51 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 37.5,
    width: 50,
    height: 50,
    rx: 6.5,
    fill: "white",
    stroke: "url(#paint0_linear_5419_6032)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 45.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 45.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#DEE1E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5419_6032",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 51,
    width: 24,
    height: 24
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 51,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5419_6032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.36 69.8889L19.7475 64.0833L14 61.4444L19.7475 58.8056L22.36 53L24.9725 58.8056L30.72 61.4444L24.9725 64.0833L22.36 69.8889ZM31.82 73L30.5275 70.0833L27.64 68.7778L30.5275 67.4444L31.82 64.5556L33.14 67.4444L36 68.7778L33.14 70.0833L31.82 73Z",
    fill: "url(#paint1_linear_5419_6032)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24.5,
    y1: 37,
    x2: 24.5,
    y2: -4.14528e-8,
    stroke: "url(#paint2_linear_5419_6032)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5419_6032",
    x1: 0.732759,
    y1: 78.5881,
    x2: 51,
    y2: 78.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5419_6032",
    x1: 14.3161,
    y1: 69.3091,
    x2: 36,
    y2: 69.3091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5419_6032",
    x1: 25.8155,
    y1: 36.4684,
    x2: 25.8155,
    y2: 3.73071e-8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalheaderimg1);
export default __webpack_public_path__ + "static/media/modalheaderimg1.7f24590995f1e1e6c905df7f3a2bb8f2.svg";
export { ForwardRef as ReactComponent };